'use strict';

var carouselShelf = require('../components/carouselShelf');

module.exports = {
    shareContentDesktop: function() {
        if (screen.width < 780) {
            $(document).on('click', '.to-share', function() {
                const url = document.location.href;
                const title = document.title;
                const image = $('.product-carousel img').attr('src');
                if('share' in navigator) {
                    navigator.share({
                        url: `${url}`
                    });
                } else {
                    this.fallbackShare(url, title, image);
                }
            });
        }
    },

    fallbackShare: function (url, title, image) {
        $('.facebook_share').attr('href', `https://www.facebook.com/sharer/sharer.php?u=${url}`);
        $('.pinterest_share').attr('href', `https://pinterest.com/pin/create/button/?url=${url}&media=${image}&description=${title}`);
        $('.whatsapp_share').attr('href', `https://api.whatsapp.com/send?text=${title}%20${url}`)

        setTimeout(function () {
            $('#share-modal').addClass('show');
        }, 300);
    },

    navigatorShare: function () {
        function shareMeModalClose(e) {
            e.preventDefault();
            $('#share-modal').remove('show');
            setTimeout(function () {
                $('#share-modal').remove()
            }, 300)
        }

        if (screen.width > 544) return;

        $('body').on('click', '.shareContent .to-share', function () {
            const url = document.location.href;
            const title = document.title;
            const image = $('.product-carousel img').attr('src');

            if ('share' in navigator) {
                navigator.share({
                    url: `${url}`
                });
            } else {
                this.fallbackShare(url, title, image);
            }
        });

        $('body').on('click', '.share-modal__bg, #share-modal--close', function (e) {
            shareMeModalClose(e);
        })
    },

    handleKeyPress: function(event) {
        if (!event) return;

        if (event.which == 13 || event.keyCode == 13) {
            event.preventDefault();
        }
    },

    onPageLoad: function (ev) {
        if (!ev) return;

        carouselShelf.hideCarouselShelf();
    },

    bindEvHandlers: function() {
        const _self = this;

        $(_self.onPageLoad);
        $(document).on('carousel:loaded', carouselShelf.hideCarouselShelf);
        $('body').on('keyup keydown keypress', '#quantity', this.handleKeyPress);
    }
};
